import { FC, useCallback } from 'react';
import { Button } from 'antd';
import { IUserData } from 'Data/interfaces/User/IUserData';
import Tooltip from 'Components/UI/Tooltip';
import { Icon } from 'Components/UI';
import { GetAvatar } from 'Utils/generateThumbnail';
import styles from './AvatarsItems.module.scss';

export interface IAvatarsItems {
  users: IUserData[];
  showDetail?: boolean;
  hideTooltip?: boolean;
  customNormalSize?: number;
  customDetailSize?: number;
  customMarginRight?: string;
  customMarginTop?: string;
  moreCustomMarginTop?: string;
  inverse?: boolean;
}

const AvatarsItems: FC<IAvatarsItems> = ({
  users,
  showDetail,
  hideTooltip,
  customNormalSize,
  customDetailSize,
  customMarginRight,
  customMarginTop,
  moreCustomMarginTop,
  inverse,
}) => {
  const detailUser = useCallback((user: IUserData) => (
    <div className={styles['detailUserWrapper']}>
      <GetAvatar
        name={user?.Nome || user?.Email || ''}
        shape='circle'
        size={customDetailSize || 32}
        src={user?.OriginalImageUrl || user?.AvatarFileName || ''}
        thumbSrc={user?.ThumbnailImageUrl}
        thumbType="small"
        border={'1px solid #FFFFFF'}
      />
      <span className={styles['detailName']}>{user?.Nome || ''}</span>
      <span className={styles['detailEmail']}>
        <Icon
          icon="email"
          customSize={12}
          customColor={'#BEC2C6'}
          style={{ marginRight: '8px', marginLeft: '-4px' }}
        />
        {user?.Email || ''}
      </span>
    </div>
  ), [customDetailSize]);

  const detailUserList = useCallback((userList: IUserData[]) => {
    if (showDetail) {
      return (
        <div className={styles['detailListUserWrapper']}>
          <span className={styles['detailTitle']}>Responsáveis</span>
          <div className={styles['detailContent']}>
            {userList.map((user, index) => (
              <div
                key={`${index}-${user.Id}`}
                className={styles['detailListUserRow']}
              >
                <GetAvatar
                  name={user?.Nome || user?.Email || ''}
                  shape='circle'
                  size={customDetailSize || 32}
                  src={user?.OriginalImageUrl || user?.AvatarFileName || ''}
                  thumbSrc={user?.ThumbnailImageUrl}
                  thumbType="small"
                  border={'1px solid #FFFFFF'}
                />
                <span className={styles['detailRight']}>
                  <span className={styles['detailName']}>{user?.Nome || ''}</span>
                  <span className={styles['detailEmail']}>{user?.Email || ''}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      )
    }
    return (
      <div className={styles['listUsers']}>
        {userList.map((work, index) => (
          <label key={`worksLabel${index}`}>
            {work?.Nome || work?.Email || ''}
          </label>
        ))}
      </div>
    );
  }, [customDetailSize, showDetail]);

  const displayWorks = useCallback(() => {
    if (users && users.length > 4) {
      const visibleUsers = users.slice(0, 3);

      const works = users.slice(3);

      return (
        <>
          {visibleUsers.map((user, index) =>
            <Tooltip
              title={!hideTooltip && (
                showDetail
                  ? detailUser(user)
                  : user?.Nome || user?.Email || ''
              )}
              placement="bottom"
              key={`SharedUser${index}`}
            >
              <div>
                <GetAvatar
                  name={user?.Nome || user?.Email || ''}
                  shape='circle'
                  size={customNormalSize || 24}
                  src={user?.OriginalImageUrl || user?.AvatarFileName || ''}
                  thumbSrc={user?.ThumbnailImageUrl}
                  thumbType="small"
                  border={'1px solid #FFFFFF'}
                  zIndex={inverse ? index : (visibleUsers.length + 1) - index}
                  marginRight={customMarginRight || '-5px'}
                  cursor='pointer'
                  marginTop={customMarginTop}
                />
              </div>
            </Tooltip>
          )}

          <Tooltip
            title={!hideTooltip && detailUserList(works)}
            placement="bottom"
          >
            <Button
              shape="circle"
              type="default"
              className={styles['buttomListUser']}
              style={{
                minWidth: `${customNormalSize || 24}px`,
                width: `${customNormalSize || 24}px`,
                height: `${customNormalSize || 24}px`,
                marginRight: customMarginRight || '-5px',
                marginTop: moreCustomMarginTop || 0,
                zIndex: inverse ? users.length + 1 : undefined,
              }}
            >
              +{works.length}
            </Button>
          </Tooltip>
        </>
      )
    }

    return (
      users.map((user, index) =>
        <Tooltip
          title={!hideTooltip && (
            showDetail
              ? detailUser(user)
              : user?.Nome || user?.Email || ''
          )}
          placement="bottom"
          key={`user${index}`}
        >
          <div>
            <GetAvatar
              name={user?.Nome || user?.Email || ''}
              shape='circle'
              size={customNormalSize || 24}
              src={user?.OriginalImageUrl || user?.AvatarFileName || ''}
              thumbSrc={user?.ThumbnailImageUrl}
              thumbType="small"
              border={'1px solid #FFFFFF'}
              zIndex={inverse ? index : (users.length + 1) - index}
              marginRight={customMarginRight || '-5px'}
              cursor='pointer'
              marginTop={customMarginTop}
            />
          </div>
        </Tooltip>
      )
    )
  }, [
    customMarginRight,
    customMarginTop,
    customNormalSize,
    moreCustomMarginTop,
    hideTooltip,
    showDetail,
    users,
    inverse,
    detailUser,
    detailUserList
  ]);

  return (
    <div>
      <div className={styles['avatarWrapper']}>
        {displayWorks()}
      </div>
    </div>
  );
}

export default AvatarsItems;
